import { KeyboardArrowDown } from '@mui/icons-material';
import { AppBar, Button, Divider, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { createStyles, withStyles } from '@mui/styles';
import { useQueryClient } from '@tanstack/react-query';
import { logoutUser } from 'lib/api';
import { getCompanyStyles } from 'lib/api/express/company';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { AuthState, logout } from 'services/redux/authSlice';
import { ClientConfigState } from 'services/redux/clientConfigSlice';
import { setConfig } from 'services/redux/clientConfigSlice';

import SideBar from './SideBar';

const styles = createStyles({
  layoutWrapper: {
    display: 'flex',
    height: '100vh', // Covers the entire viewport height
  },
  content: {
    width: '100%',
    flexGrow: 1, // Allows it to grow and consume available space
    display: 'flex', // Added to facilitate flex-based layout
    flexDirection: 'column', // Stack children vertically
  },
  layout: {
    flexGrow: 1, // Allows it to grow and consume available space
    overflowX: 'auto', // Enables vertical scrolling
    padding: '0px 20px',
    backgroundColor: '#F8FAFC',
    boxSizing: 'border-box',
  },
  loading: {
    opacity: 0.6,
    pointerEvents: 'none',
  },
});

const WhiteAppBar = styled(AppBar)({
  padding: 2,
  backgroundColor: '#fff',
  borderBottom: '1px solid #eaecf0',
});

const PruffConnectLayout = (props: any) => {
  const { children, classes } = props;
  const auth = useSelector((state: { auth: AuthState }) => state.auth);
  const expressConfig = useSelector(
    (state: { clientConfiguration: ClientConfigState }) =>
      state.clientConfiguration.configs,
  );
  const domain = window.location.hostname; // Get 'banpro.pruff.com'
  const subdomain = domain.split('.')[0]; // Get 'banpro'
  const finalClientId = subdomain;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleLogout = async () => {
    const response = await logoutUser(dispatch);
    if (response.success) {
      queryClient.clear();
      dispatch(logout());
    }
  };

  const isInCorrectPortal = async () => {
    if (auth.isAuthenticated && auth?.user?.clientId !== finalClientId) {
      dispatch(logout());
      return false;
    }
    return true;
  };

  const setUpClientConfiguration = async () => {
    try {
      const correctPortal = await isInCorrectPortal();
      if (!correctPortal) return;
      if (!finalClientId) return;
      if (!expressConfig || expressConfig.finalClientId !== finalClientId) {
        const response = await getCompanyStyles(finalClientId);
        dispatch(setConfig({ ...response, finalClientId }));
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  useEffect(() => {
    void setUpClientConfiguration();
  }, []);

  return (
    <div>
      <WhiteAppBar position="static" elevation={0}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '4px 0px',
            width: '96%',
            margin: 'auto',
            alignItems: 'center',
            maxHeight: '60px',
          }}
        >
          <img
            width={160}
            src={`https://pruff-public.s3.amazonaws.com/company-logos/${expressConfig?.companyId}.png`}
            alt="Logo"
          />
          <div>
            {auth.isAuthenticated && (
              <div>
                <Button
                  ref={buttonRef}
                  aria-controls="client-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                  style={{
                    color: expressConfig?.pruffConnect_styles_mainColor,
                  }}
                  endIcon={<KeyboardArrowDown />}
                >
                  {auth.user?.name}
                </Button>
                <Menu
                  id="client-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  keepMounted
                  MenuListProps={{
                    style: {
                      minWidth: buttonRef.current
                        ? buttonRef.current.offsetWidth
                        : undefined,
                    },
                  }}
                >
                  <MenuItem disabled>{auth.user?.companyName}</MenuItem>
                  <Divider />
                  <MenuItem
                    onClick={() => {
                      void handleLogout();
                      handleClose();
                    }}
                  >
                    Salir
                  </MenuItem>
                </Menu>
              </div>
            )}
          </div>
        </div>
      </WhiteAppBar>
      <div className={classes.layoutWrapper}>
        {auth.isAuthenticated && <SideBar />}
        <div className={classes.content}>
          <div className={`${classes.layout}`}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(PruffConnectLayout);
